import { MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'ruleIcon'
})
export class RuleIconPipe implements PipeTransform {

	transform(_type: int): string {
		switch (_type) {
			case (MetadataAuthoringRule.AND): return '&';
			case (MetadataAuthoringRule.NOT): return '!';
			case (MetadataAuthoringRule.OR): return '?';
			case (MetadataAuthoringRule.EXPRESSION): return 'faSensor';
			case (MetadataAuthoringRule.REFERENCE): return 'faClipboardList';
			default: return 'faClipboardList';
		}
	}

}
